module.exports = "<ul class=\"dev-bubble-list\"></ul>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/membersBubble/templates/button.hbs
// module id = 668
// module chunks = 0